import lib from '@/library'

export default {
  computed: {
    url_mode () {
      return lib.cdu.urlParameters.getMode()
    },

    url_screenId () {
      return lib.cdu.urlParameters.getScreenId()
    },

    url_big3columns () {
      return lib.cdu.urlParameters.getBig3Columns()
    },

    url_brand () {
      return lib.cdu.urlParameters.getBrand()
    },

    url_template () {
      return lib.cdu.urlParameters.getTemplate()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/UrlParameters.js